import { useState, useEffect, useContext } from 'react';
import { SolanaContext } from '../contexts/solanaContext';
import * as anchor from '@project-serum/anchor';
import { Connection, PublicKey, clusterApiUrl } from '@solana/web3.js';
import kingdomofants from '../components/ABI/kingdomofants.json';
import bossFight from '../components/ABI/bossFight.json';

import { useDispatch } from 'react-redux';
import { setNftError, setNftLoading, setNftsStore,setLeveledNftsStore,setLeveledNftLoading, setLeveledNftError,setBossedNftsStore,setBossedNftLoading, setBossedNftError } from '../store/appSlice';
import { fetchNFTsOnchain } from '../apis';

const network = clusterApiUrl('devnet');
const opts = { preflightCommitment: 'processed' };
const kingdomofantsProgramID = new PublicKey(kingdomofants.metadata.address);
const bossFightProgramID = new PublicKey(bossFight.metadata.address);


const useFetchNfts = () => {
  const { wallet } = useContext(SolanaContext);
  const [nfts, setNfts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const dispatch = useDispatch()

  const calculateTimePassed = (startTime) => {
    const currentTime = Date.now();
    const timeDiff = currentTime - (Number(startTime) * 1000); // Assuming startTime is a UNIX timestamp in seconds
    const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    return `${days} D ${hours} H`;
};

const calculateHoursPassed = (startTime) => {
  const currentTime = Date.now();
  const timeDiff = currentTime - (Number(startTime) * 1000); // Assuming startTime is a UNIX timestamp in seconds
  const hoursPassed = timeDiff / (1000 * 60 * 60); // Convert milliseconds to hours
  return hoursPassed;
};

  const fetchNfts = async (delay=0) => {
    if (!wallet.connected) {
      console.log('Wallet not connected.');
      return;
    }

    dispatch(setNftLoading(true))
    dispatch(setNftError(null))
    setIsLoading(true);
    setError(null);
       
    try {
      const nfts = await fetchNFTsOnchain(wallet.publicKey.toString(), delay)
      console.log('all nfts', nfts)

      // Establish a connection and program
      const connection = new Connection(network, opts.preflightCommitment);
      const provider = new anchor.AnchorProvider(connection, wallet, opts.preflightCommitment);
      const program = new anchor.Program(kingdomofants, kingdomofantsProgramID, provider);
      let userNfts = []
      console.log(nfts);
      await Promise.all(nfts.map(async (nft) => {
        try {
          const [nftAccount] = await PublicKey.findProgramAddress(
            [Buffer.from('ANT-STATE-SEED'),wallet.publicKey.toBuffer(), new PublicKey(nft.mint).toBuffer()],
            kingdomofantsProgramID
          );
          const nftAccountDetails = await program.account.antState.fetch(nftAccount);
            // Include this NFT only if it is not leveled
          userNfts.push( {
            ...nft,
            type: nftAccountDetails.nftType,
            level: nftAccountDetails.level,
            remainPotions: nftAccountDetails.remainPotions,
          });
          return
        } catch (error) {
          console.error(`Failed to fetch details for NFT ${nft.mint}:`, error);
          return null; // In case of an error, exclude this NFT
        }
      }));

      // Filter out null values (NFTs that were excluded)
      setNfts(userNfts);
      dispatch(setNftsStore(userNfts))
      } catch (error) {
        console.error('Failed to fetch NFTs:', error);
        setError(error);
        dispatch(setNftError(error))
      } finally {
        setIsLoading(false);
        dispatch(setNftLoading(false))
      }
  };

  const fetchLeveledNfts = async(delay=0) => {
    if (!wallet.connected) {
      console.log('Wallet not connected.');
      return;
    }

    dispatch(setLeveledNftLoading(true))
    dispatch(setLeveledNftError(null))
    setIsLoading(true);
    setError(null);
       
    try {
      // Establish a connection and program
      const connection = new Connection(network, opts.preflightCommitment);
      const provider = new anchor.AnchorProvider(connection, wallet, opts.preflightCommitment);
      const program = new anchor.Program(kingdomofants, kingdomofantsProgramID, provider);

      const [stakeStateInfoAccount, _bump2] = await anchor.web3.PublicKey.findProgramAddress(
        [
          Buffer.from(process.env.REACT_APP_STATE_STATE_SEED),
          wallet.publicKey.toBuffer()
        ],
        kingdomofantsProgramID
      );
  
      const stakedStateInfoData = await program.account.stakedNftOfUser.fetch(stakeStateInfoAccount);

      let userNfts = [];
      await Promise.all(stakedStateInfoData.levelNfts.map(async (nft) => {
        try {
          const [nftAccount] = await PublicKey.findProgramAddress(
            [Buffer.from('ANT-STATE-SEED'),wallet.publicKey.toBuffer(), new PublicKey(nft.address).toBuffer()],
            kingdomofantsProgramID
          );
          const nftAccountDetails = await program.account.antState.fetch(nftAccount);
       
          const levelGroundUpdatedTimeString = calculateTimePassed(nftAccountDetails.levelGroundUpdatedTime);
          const hoursPassed = calculateHoursPassed(nftAccountDetails.levelGroundUpdatedTime);
          
          userNfts.push( {
            address: nft.address.toString(),
            image: nft.image,
            name: nftAccountDetails.nftType?`Premium Worker ANT ${nftAccountDetails.batchIndex} -${nftAccountDetails.tokenIdOfBatch}`:`Basic Worker ANT ${nftAccountDetails.batchIndex} -${nftAccountDetails.tokenIdOfBatch}`,
            type: nftAccountDetails.nftType,
            boolLeveled: nftAccountDetails.boolLeveled,
            level: nftAccountDetails.level,
            remainPotions: nftAccountDetails.remainPotions,
            levelGroundRemainPotions: nftAccountDetails.levelGroundRemainPotions,
            levelGroundUpdatedTimeString,
            hoursPassed,
          });
          console.log(userNfts);

          return
        } catch (error) {
          console.error(`Failed to fetch details for NFT ${nft.mint}:`, error);
          return null; // In case of an error, exclude this NFT
        }
      }));

      // Filter out null values (NFTs that were excluded)
      dispatch(setLeveledNftsStore(userNfts))
      setNfts(userNfts);
      } catch (error) {
        console.error('Failed to fetch NFTs:', error);
        setError(error);
        dispatch(setLeveledNftError(error))
      } finally {
        setIsLoading(false);
        dispatch(setLeveledNftLoading(false))
      }
  };

  // useEffect(() => {
  //   fetchNfts();
  // }, [wallet.connected, wallet.publicKey]);

  return { nfts, isLoading, error, fetchLeveledNfts, fetchNfts };
};

export default useFetchNfts;